var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-profile-orders"},[_vm._l((_vm.orderConnection.orders),function(order){return _c('ProfileOrder',{key:order.id,attrs:{"order":order}})}),_c('AppTitleBar',{attrs:{"title":"주문/배송"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }